// Module
var code = `<div class="document-area"><div ng-if="\$ctrl.url == null" class="document-area-internal">&nbsp;Loading&hellip;</div></div>`;
// Exports
export default code;